import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

const CHAVE_DESTINO = 'login.destino';

// Caminhos para onde o login já leva, ou que não fazem sentido retomar.
const SEM_RETOMAR = ['/', '/dashboard', '/404', '/twofactor', '/newpassword', '/forgotpassword'];

/**
 * O login do Keycloak sempre volta para `/dashboard` (`redirectUri` fixo em `src/index.js`), então quem abre
 * um link direto (ou recarrega a página) cairia no início. Chamado antes do `init`: guarda o caminho na aba.
 */
export function guardarDestino() {
  const { pathname, search } = window.location;
  if (SEM_RETOMAR.includes(pathname)) return;
  try {
    window.sessionStorage.setItem(CHAVE_DESTINO, `${pathname}${search}`);
  } catch (error) {
    // Sem sessionStorage (modo privado restrito): depois do login a pessoa navega pelo menu.
  }
}

/** Depois do login, volta para o caminho guardado por `guardarDestino`. */
export function RetomarDestino() {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!initialized || !keycloak?.authenticated) return;
    let destino = null;
    try {
      destino = window.sessionStorage.getItem(CHAVE_DESTINO);
      window.sessionStorage.removeItem(CHAVE_DESTINO);
    } catch (error) {
      return;
    }
    // Só caminhos internos: `//host` seria outro site.
    if (!destino || !destino.startsWith('/') || destino.startsWith('//')) return;
    if (destino !== `${pathname}${search}`) navigate(destino, { replace: true });
  }, [initialized, keycloak?.authenticated, navigate, pathname, search]);

  return null;
}
